import { AlertTriangle, ExternalLink } from "lucide-react";
import {
  PADSPLIT_DIRECT_MESSAGE_URL,
  MESSAGING_OUTAGE_BANNER_TEXT,
} from "@shared/messaging-outage";

/**
 * Replaces an outbound compose box while the admin global messaging-outage
 * toggle is ON. Directs the host to send messages directly through PadSplit.
 */
export function MessagingOutageBanner({ className }: { className?: string }) {
  return (
    <div
      className={`rounded-md border border-brand/30 bg-brand/5 px-4 py-3 text-sm ${className ?? ""}`}
      data-testid="banner-messaging-outage"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 shrink-0 text-brand mt-0.5" />
        <div className="space-y-2">
          <p className="text-foreground" data-testid="text-messaging-outage-banner">
            {MESSAGING_OUTAGE_BANNER_TEXT}
          </p>
          <a
            href={PADSPLIT_DIRECT_MESSAGE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 font-medium text-brand hover:underline"
            data-testid="link-messaging-outage-padsplit"
          >
            <ExternalLink className="h-4 w-4" />
            Send messages directly through PadSplit
          </a>
        </div>
      </div>
    </div>
  );
}
